<nb-tag
  appearance="outline"
  status="info"
  *ngFor="let tree of trees"
  [text]="tree"
  size="tiny"
  (click)="selected(tree)"
></nb-tag>
